/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import api from "@/lib/api";

const GIORNI = [
  { n: 1, label: "Lunedì" },
  { n: 2, label: "Martedì" },
  { n: 3, label: "Mercoledì" },
  { n: 4, label: "Giovedì" },
  { n: 5, label: "Venerdì" },
];

const STATO_LABEL = {
  pending: { txt: "⏳ In attesa di conferma", color: "#ef6c00", bg: "#fff3e0" },
  ricevuta: { txt: "📥 Ricevuta · in verifica", color: "#ef6c00", bg: "#fff3e0" },
  confirmed: { txt: "⏳ In attesa pagamento", color: "#1b5e20", bg: "#c8e6c9" },
  in_attesa_pagamento: { txt: "💳 In attesa pagamento", color: "#4a148c", bg: "#f3e5f5" },
  accettata_mail_inviata: { txt: "💳 In attesa pagamento", color: "#4a148c", bg: "#f3e5f5" },
  confermata_genitore: { txt: "✓ Confermata (in attesa pag.)", color: "#004d40", bg: "#b2dfdb" },
  accettata: { txt: "✅ Accettata", color: "#1b5e20", bg: "#a5d6a7" },
  rejected: { txt: "✕ Iscrizione rifiutata", color: "#b71c1c", bg: "#ffcdd2" },
  rifiutata: { txt: "✕ Rifiutata", color: "#b71c1c", bg: "#ffcdd2" },
  waiting: { txt: "📋 In lista d'attesa", color: "#6a1b9a", bg: "#f3e5f5" },
  scaduta: { txt: "⏰ Iscrizione scaduta", color: "#5d4037", bg: "#d7ccc8" },
  pagata_da_verificare: { txt: "💳 Pagata · in verifica", color: "#0d47a1", bg: "#e3f2fd" },
  pagata: { txt: "💳 Pagata e verificata", color: "#1b5e20", bg: "#a5d6a7" },
};

export default function SpotAlunnoSection({ setToast }) {
  const [data, setData] = useState(null);
  const [cfg, setCfg] = useState(null);
  const [mie, setMie] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
  const [selGiorni, setSelGiorni] = useState([]); // array di giorni selezionati (1..5)
  const [nota, setNota] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const load = async () => {
    setLoading(true); setErr(null);
    try {
      const [d, c, m] = await Promise.all([
        api.get("/mensa-matrice/spot/alunno/disponibilita"),
        api.get("/mensa-matrice/spot-config"),
        api.get("/alunni-portal/extra/mie-iscrizioni"),
      ]);
      setData(d.data);
      setCfg(c.data);
      setMie(m.data?.items || []);
    } catch (e) {
      setErr(e.response?.data?.detail || "Errore caricamento");
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const occupatiByGiorno = {};
  (data?.occupati || []).forEach(o => {
    if (!occupatiByGiorno[o.giorno]) occupatiByGiorno[o.giorno] = [];
    occupatiByGiorno[o.giorno].push(o);
  });
  const propriaSpot = data?.propria_spot;
  // I giorni di una richiesta ancora "ricevuta" (in attesa) NON occupano la mensa:
  // vanno mostrati come "in attesa" ma il resto della matrice resta selezionabile.
  const ricevutaGiorni = (propriaSpot && propriaSpot.stato === "ricevuta") ? (propriaSpot.giorni || []) : [];

  const toggleGiorno = (n) => {
    setSelGiorni(curr => curr.includes(n) ? curr.filter(x => x !== n) : [...curr, n].sort());
  };

  const richiedi = async () => {
    if (selGiorni.length === 0) return;
    setSubmitting(true);
    try {
      await api.post("/mensa-matrice/spot/alunno/richiedi", { giorni: selGiorni, nota });
      setToast && setToast({ type: "success", msg: "Richiesta inviata! Sarà verificata dalla segreteria." });
      setSelGiorni([]);
      setNota("");
      await load();
    } catch (e) {
      setToast && setToast({ type: "error", msg: e.response?.data?.detail || "Errore invio richiesta" });
    } finally { setSubmitting(false); }
  };

  if (loading) return <div style={{ padding: 20, color: "#666" }}>Caricamento…</div>;
  if (err) return <div data-testid="spot-alunno-err" style={{ padding: 14, background: "#ffebee", border: "1px solid #ef9a9a", color: "#c62828", borderRadius: 4 }}>{err}</div>;

  return (
    <div data-testid="spot-alunno-section">
      <div style={{ background: "white", borderRadius: 6, padding: 22, boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
        <h2 style={{ fontSize: 18, color: "#00695c", margin: "0 0 8px" }}>🍽️ Adesione mensa SPOT</h2>
        <div style={{ fontSize: 12, color: "#555", marginBottom: 16, lineHeight: 1.5 }}>
          Seleziona il <b>giorno della settimana</b> in cui desideri usufruire ricorrentemente della mensa
          per tutto l'anno scolastico {data?.anno || ""}.
        </div>

        {/* Stato propria richiesta esistente */}
        {propriaSpot && (
          <div data-testid="spot-mia-richiesta" style={{ padding: 12, background: propriaSpot.stato === "accettata" ? "#e8f5e9" : "#fff8e1", border: `2px solid ${propriaSpot.stato === "accettata" ? "#4caf50" : "#ffa726"}`, borderRadius: 4, marginBottom: 16, fontSize: 12 }}>
            {propriaSpot.stato === "accettata" ? "✅" : "⏳"} La tua adesione mensa SPOT per <b>{(propriaSpot.giorni || []).map(g => GIORNI.find(x => x.n === g)?.label).join(", ")}</b> è <b>{propriaSpot.stato === "accettata" ? "accettata" : "in fase di verifica"}</b>.
          </div>
        )}

        {(propriaSpot?.stato !== "accettata") && (
          <>
            {/* Matrice 5 giorni con stato (SELEZIONE MULTIPLA) */}
            <div data-testid="spot-matrice" style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 8, marginBottom: 14 }}>
              {GIORNI.map(g => {
                const occ = occupatiByGiorno[g.n] || [];
                const isOccupied = occ.length > 0;
                const isPending = !isOccupied && ricevutaGiorni.includes(g.n);
                const isLocked = isOccupied || isPending;
                const isSel = selGiorni.includes(g.n);
                return (
                  <button key={g.n} onClick={() => !isLocked && toggleGiorno(g.n)}
                    data-testid={`spot-giorno-${g.n}`} disabled={isLocked}
                    title={isOccupied ? occ.map(o => o.dettaglio).join(" · ") : (isPending ? "Richiesta già inviata per questo giorno — in attesa di verifica" : "Disponibile — clicca per selezionare/deselezionare")}
                    style={{
                      padding: "16px 8px", borderRadius: 6, cursor: isLocked ? "not-allowed" : "pointer",
                      background: isOccupied ? "#eceff1" : (isPending ? "#fff3e0" : (isSel ? "#00695c" : "white")),
                      color: isOccupied ? "#90a4ae" : (isPending ? "#ef6c00" : (isSel ? "white" : "#00695c")),
                      border: `2px solid ${isOccupied ? "#cfd8dc" : (isPending ? "#ffb74d" : (isSel ? "#004d40" : "#00695c"))}`,
                      fontSize: 13, fontWeight: 700, textAlign: "center",
                      transition: "all 0.15s",
                    }}>
                    <div style={{ fontSize: 14, marginBottom: 4 }}>{g.label}</div>
                    {isOccupied ? (
                      <div style={{ fontSize: 9, lineHeight: 1.3, marginTop: 4, fontWeight: 500 }}>
                        {occ.map((o, i) => <div key={i}>🔒 {o.dettaglio}</div>)}
                      </div>
                    ) : isPending ? (
                      <div style={{ fontSize: 9, lineHeight: 1.3, marginTop: 4, fontWeight: 600 }}>
                        ⏳ In attesa
                      </div>
                    ) : (
                      <div style={{ fontSize: 10, marginTop: 4, fontWeight: 500, opacity: 0.85 }}>
                        {isSel ? "✓ Selezionato" : "Disponibile"}
                      </div>
                    )}
                  </button>
                );
              })}
            </div>

            <div style={{ fontSize: 11, color: "#666", marginBottom: 14, fontStyle: "italic" }}>
              💡 Suggerimento: puoi selezionare uno o più giorni della settimana cliccando sulle caselle disponibili.
            </div>

            {selGiorni.length > 0 && (
              <div style={{ marginBottom: 14 }}>
                <label style={{ fontSize: 11, fontWeight: 700, color: "#555", display: "block", marginBottom: 4 }}>
                  Note per la segreteria (facoltativo)
                </label>
                <textarea value={nota} onChange={e => setNota(e.target.value)} rows={2} maxLength={500}
                  data-testid="spot-nota"
                  placeholder="Es. intolleranze, motivazioni…"
                  style={{ width: "100%", padding: 8, border: "1px solid #cfd8dc", fontSize: 12, fontFamily: "inherit", borderRadius: 3 }} />
              </div>
            )}

            <button onClick={richiedi} disabled={selGiorni.length === 0 || submitting}
              data-testid="spot-richiedi"
              style={{ padding: "10px 22px", background: selGiorni.length > 0 ? "#00695c" : "#bdbdbd", color: "white", border: "none", fontSize: 13, fontWeight: 800, cursor: (selGiorni.length === 0 || submitting) ? "not-allowed" : "pointer", borderRadius: 3 }}>
              {submitting ? "Invio…" : `📨 Invia richiesta${selGiorni.length > 0 ? ` (${selGiorni.length} ${selGiorni.length === 1 ? "giorno" : "giorni"})` : ""}`}
            </button>
          </>
        )}

        {/* Nota fissa dall'admin */}
        {cfg?.nota_alunno && (
          <div style={{ marginTop: 18 }}>
            <div data-testid="spot-nota-label" style={{
              display: "inline-block", padding: "4px 14px",
              background: "#c62828", color: "white", fontWeight: 800,
              fontSize: 12, letterSpacing: 0.5, textTransform: "uppercase",
              borderRadius: "4px 4px 0 0",
            }}>
              ⚠️ Nota importante
            </div>
            <div data-testid="spot-nota-alunno-box" style={{ padding: 12, background: "#e1f5fe", border: "1px solid #4fc3f7", borderRadius: "0 4px 4px 4px", fontSize: 11, color: "#01579b", lineHeight: 1.6 }}>
              {cfg.nota_alunno}
            </div>
          </div>
        )}
      </div>

      {/* Le mie iscrizioni (riepilogo unificato Extra + SPOT) */}
      {mie.length > 0 && (
        <div data-testid="spot-mie-iscrizioni" style={{ marginTop: 14, background: "white", padding: 14, borderRadius: 6, boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
          <div style={{ fontSize: 13, fontWeight: 800, color: "#0d47a1", marginBottom: 10 }}>📋 LE MIE ISCRIZIONI</div>
          <table style={{ width: "100%", fontSize: 11, borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#37474f", color: "white" }}>
                <th style={{ textAlign: "left", padding: 6 }}>RICHIESTA</th>
                <th style={{ textAlign: "center", padding: 6 }}>STATO</th>
                <th style={{ textAlign: "left", padding: 6 }}>NOTE</th>
              </tr>
            </thead>
            <tbody>
              {mie.map(m => {
                const lbl = STATO_LABEL[m.stato_iscrizione] || STATO_LABEL.pending;
                return (
                  <tr key={m.id} data-testid={`spot-mia-${m.id}`} style={{ borderTop: "1px solid #eee" }}>
                    <td style={{ padding: 6 }}>
                      <div style={{ fontWeight: 700 }}>
                        {m.kind === "spot" ? "🍽️ " : "📚 "}
                        {m.corso_descrizione || m.corso_codice}
                      </div>
                      <div style={{ fontSize: 9, color: "#888", fontFamily: "monospace" }}>
                        A.S. {m.anno}
                        {m.tariffa_etichetta ? ` · ${m.tariffa_etichetta}` : ""}
                        {m.giorni_scelti ? ` · ${m.giorni_scelti}` : ""}
                      </div>
                      {m.created_at && (
                        <div style={{ fontSize: 10, color: "#37474f", fontFamily: "monospace", marginTop: 2 }}
                          title={`Data e ora di invio della richiesta: ${m.created_at}`}>
                          🕒 {(() => { try { return new Date(m.created_at).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }); } catch { return m.created_at; } })()}
                        </div>
                      )}
                    </td>
                    <td style={{ textAlign: "center", padding: 6 }}>
                      <span style={{ padding: "2px 8px", background: lbl.bg, color: lbl.color, fontWeight: 800, borderRadius: 2 }}>{lbl.txt}</span>
                    </td>
                    <td style={{ padding: 6, fontSize: 10, color: "#555", maxWidth: 200 }}>
                      {m.note_admin && <div style={{ color: "#b71c1c" }}><b>Motivo:</b> {m.note_admin}</div>}
                      {m.note_studente && <div>{m.note_studente}</div>}
                      {!m.note_admin && !m.note_studente && <span style={{ color: "#bbb" }}>—</span>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
